import {
  useTheme
} from "./chunk-JVDTBYWX.js";
import {
  collapseTheme
} from "./chunk-4JMI2FIT.js";

// src/components/collapse.tsx
import * as React from "react";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
function CollapseRoot({ as, open, className, children, ...props }, ref) {
  const Component = as ?? "div";
  const contextTheme = useTheme();
  const theme = contextTheme?.collapse ?? collapseTheme;
  const styles = twMerge(theme.baseStyle, className);
  return open ? /* @__PURE__ */ jsx(Component, { ...props, ref, "data-open": open, className: styles, children }) : null;
}
CollapseRoot.displayName = "MaterialTailwind.Collapse";
var Collapse = React.forwardRef(CollapseRoot);
var collapse_default = Collapse;

export {
  Collapse,
  collapse_default
};
